// ../internal/src/components/meso-viewability/meso-viewability.ts
import React, { useCallback } from "react";
var useMesoViewability = function(param) {
    var viewabilityBeacon = param.viewabilityBeacon;
    var componentRef = React.useRef(null);
    var deRegisterViewability = useCallback(function() {
        if (componentRef.current && window.meso) {
            var _window_meso_viewability;
            window.meso.viewability = (_window_meso_viewability = window.meso.viewability) !== null && _window_meso_viewability !== void 0 ? _window_meso_viewability : [];
            window.meso.viewability.push({
                type: "deregister",
                element: componentRef.current
            });
        }
    }, []);
    var registerViewability = useCallback(function() {
        if (componentRef.current) {
            var _window_meso;
            window.meso = (_window_meso = window.meso) !== null && _window_meso !== void 0 ? _window_meso : {};
            var _window_meso_viewability;
            window.meso.viewability = (_window_meso_viewability = window.meso.viewability) !== null && _window_meso_viewability !== void 0 ? _window_meso_viewability : [];
            window.meso.viewability.push({
                type: "register",
                config: "image",
                // the config settings to use: image, video, or large-image
                element: componentRef.current,
                // reference to the DOM element
                beacon: viewabilityBeacon
            });
        }
    }, [
        viewabilityBeacon
    ]);
    React.useEffect(function() {
        registerViewability();
        return deRegisterViewability;
    }, [
        registerViewability,
        deRegisterViewability
    ]);
    return {
        componentRef: componentRef
    };
};
// src/components/meso-viewability-wrapper/meso-viewability-wrapper.ts
var useMesoViewabilityWrapper = function(param) {
    var viewabilityBeacon = param.viewabilityBeacon;
    return useMesoViewability({
        viewabilityBeacon: viewabilityBeacon
    });
};
useMesoViewabilityWrapper.displayName = "useMesoViewabilityWrapper";
export { useMesoViewabilityWrapper };
//# sourceMappingURL=index.js.map